import React from 'react'
import CustomSlides from '../../component/common/CustomSlides'

// const service = [
//     { imagesUrl: "Mask group (1)", name: "Plumbing" },
//     { imagesUrl: "Mask group (2)", name: "Electric Work" },
//     { imagesUrl: "Mask group (3)", name: "Carpentry" },
//     { imagesUrl: "Mask group (4)", name: "Cleaning Services" },

// ]

const Services= () =>{
    return (
        <>
            
            <div className='maincontainer'>
                <h2 className='title mt-4 mb-4'>Services</h2>
                <div>
                <CustomSlides/>
                </div>
{/*                
                <div className='row'>
                    {
                        service.map((service, index) => {
                            return (
                                <div className="col-lg-3 col-md-4 col-sm-6">
                                    <div className="services-imagebox" key={index}>
                                        <div className="recent-service-thumbnail">
                                            <img src={`assets/images/${service.imagesUrl}.png`} alt="" />
                                        </div>
                                        <div className="services-content">
                                            <div className="services-content-box-inner">
                                                <p>{service.name}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div> */}
            </div>
        </>
    )
}

export default Services;